import { render, staticRenderFns } from "./TestarIntegracaoModal.vue?vue&type=template&id=38898a20&scoped=true&"
import script from "./TestarIntegracaoModal.vue?vue&type=script&lang=js&"
export * from "./TestarIntegracaoModal.vue?vue&type=script&lang=js&"
import style0 from "./TestarIntegracaoModal.vue?vue&type=style&index=0&id=38898a20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38898a20",
  null
  
)

export default component.exports